import Axios from "../utils/Axios";

export const getUser = async () => {
  const response = await Axios.get("/@me");
  return response.data;
};

export const login = async (data: { email: string; password: string }) => {
  const response = await Axios.post("/login", data);
  return response.data;
};

export const logout = async () => {
  const response = await Axios.post("/logout");
  return response.data?.logout;
};

export const verifyOtp = async (otp: string) => {
  const response = await Axios.post("/verify-otp", { otp });
  return response.data;
};

export const resendOtp = async () => {
  const response = await Axios.post("/resend-otp");
  return response.data;
};
